export const SAVED = 'SAVED';
export const SUBMITTED = 'SUBMITTED';

export const SOLAR_ENERGY_TECHNOLOGY = 'solar';
export const STORAGE_ENERGY_TECHNOLOGY = 'storage';
export const SOLAR_AND_STORAGE_ENERGY_TECHNOLOGY = 'solar + storage';

export const DATE_FORMAT = 'MM/DD/YYYY';
